import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  direction: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};
